var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 20.970703 1 A 1.0001 1.0001 0 0 0 20.59375 1.0859375 L 11.714844 5.03125 C 11.624515 5.018834 11.53526 5 11.443359 5 L 7 5 C 5.897 5 5 5.897 5 7 L 5 13 C 2.8026661 13 1 14.802666 1 17 L 1 18 L 1.203125 18 C 1.6594792 19.706363 3.1564058 21 5 21 L 17 21 C 18.843594 21 20.340521 19.706363 20.796875 18 L 21 18 L 21 17 C 21 14.802666 19.197334 13 17 13 L 17 11.220703 C 17 10.653703 16.808922 10.092703 16.419922 9.5957031 L 13.585938 6.390625 L 20 3.5390625 L 20 7.5 C 20 7.7869372 19.786937 8 19.5 8 C 19.213063 8 19 7.7869372 19 7.5 L 17 7.5 C 17 8.8690628 18.130937 10 19.5 10 C 20.869063 10 22 8.8690628 22 7.5 L 22 2 A 1.0001 1.0001 0 0 0 20.970703 1 z M 9 7 L 11.517578 7.0664062 L 14.111328 10 L 9 10 L 9 7 z M 5 15 L 17 15 C 18.116666 15 19 15.883334 19 17 C 19 18.116666 18.116666 19 17 19 L 5 19 C 3.8833339 19 3 18.116666 3 17 C 3 15.883334 3.8833339 15 5 15 z M 5 16 A 1 1 0 0 0 4 17 A 1 1 0 0 0 5 18 A 1 1 0 0 0 6 17 A 1 1 0 0 0 5 16 z M 9 16 A 1 1 0 0 0 8 17 A 1 1 0 0 0 9 18 A 1 1 0 0 0 10 17 A 1 1 0 0 0 9 16 z M 13 16 A 1 1 0 0 0 12 17 A 1 1 0 0 0 13 18 A 1 1 0 0 0 14 17 A 1 1 0 0 0 13 16 z M 17 16 A 1 1 0 0 0 16 17 A 1 1 0 0 0 17 18 A 1 1 0 0 0 18 17 A 1 1 0 0 0 17 16 z",
    fill: "#000000"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrane);
export default __webpack_public_path__ + "static/media/crane.a6926e46b56a843b9f5a3aff72c1c961.svg";
export { ForwardRef as ReactComponent };